import { Button } from '@1trading/react';
import { Loader2 } from 'lucide-react';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

/**
 * Landing route for the Keycloak redirect (`${origin}/callback`). `AuthProvider`
 * exchanges the authorization code automatically; this page just waits for the
 * result and forwards to the dashboard, replacing history so Back does not
 * re-trigger the callback.
 */
export const CallbackPage = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [auth.isAuthenticated, navigate]);

  if (auth.error) {
    return (
      <main className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-background px-6 text-center text-foreground">
        <h1 className="font-semibold text-2xl">Sign-in failed</h1>
        <p className="max-w-md text-muted-foreground text-sm">{auth.error.message}</p>
        <Button onClick={() => void auth.signinRedirect()}>Try again</Button>
      </main>
    );
  }

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-background text-foreground">
      <Loader2 aria-hidden className="size-6 animate-spin text-muted-foreground" />
      <p className="text-muted-foreground text-sm">Completing sign in…</p>
    </main>
  );
};
